import * as React from 'react';
import { FixedSizeList, FixedSizeListProps } from 'react-window';

const VirtualizedList = ({
  height,
  children,
  initialScrollOffset,
  innerRef,
  innerElementType,
  itemCount,
  itemData,
  itemKey,
  itemSize,
  layout,
  onItemsRendered,
  onScroll,
  outerRef,
  outerElementType,
  overscanCount,
  style,
  useIsScrolling,
  width
}: FixedSizeListProps) => {
  return (
    <FixedSizeList
      height={height}
      initialScrollOffset={initialScrollOffset}
      innerRef={innerRef}
      innerElementType={innerElementType}
      itemCount={itemCount}
      itemData={itemData}
      itemKey={itemKey}
      itemSize={itemSize}
      layout={layout}
      onItemsRendered={onItemsRendered}
      onScroll={onScroll}
      outerRef={outerRef}
      outerElementType={outerElementType}
      overscanCount={overscanCount}
      style={style}
      useIsScrolling={useIsScrolling}
      width={width}
    >
      {children}
    </FixedSizeList>
  );
};

VirtualizedList.displayName = 'VirtualizedList';

export { VirtualizedList };
